import { Styles } from "./App";
import "../styles/BottomSection.css";
import { Link } from "react-router-dom";
import pinterestImg from "../iamges/pinterest.png";
import facebookImg from "../iamges/facebook.png";
import instaImg from "../iamges/insta.png";
import linkedinImg from "../iamges/linkedin.png";
import twitterImg from "../iamges/twitter.png";
import youtubImg from "../iamges/youtub.png";
import React from "react";
import MarqueeInfo from "./MarqueeInfo";

const BottomSection = () => {
  const socialMedia = [
    // { name: "pinterest", icon: pinterestImg },
    // { name: "youtub", icon: youtubImg },
    // { name: "twitter", icon: twitterImg },
    {
      name: "insta",
      icon: instaImg,
      link: "https://www.instagram.com/homeowner_app/",
    },
    {
      name: "facebook",
      icon: facebookImg,
      link: "https://www.facebook.com/HomeOwnerApp",
    },
    // { name: "linkedin", icon: linkedinImg },
  ];
  return (
    <>
      <div className='bg-[#171717] text-white p-12'>
        <div className='container mx-auto flex flex-col md:flex-row justify-between'>
          <div className='md:w-1/3 space-y-4 py-4'>
            <h2 className='footer-download-text'>Download the app today!</h2>

            <div>
              <button className='rounded-md '>
                <a
                  href='https://play.google.com/store/apps/details?id=com.arptix.homeowner'
                  target='_blank'>
                  <img
                    src={require("../iamges/android.png")}
                    style={{ width: 135 }}
                    alt=''
                    className='mx-auto'
                  />
                </a>
              </button>
              &nbsp; &nbsp;
              <button className='rounded-md'>
                <a
                  href='https://apps.apple.com/ca/app/homeowner/id6448795356'
                  target='_blank'>
                  <img
                    style={{ width: 120 }}
                    src={require("../iamges/apple.png")}
                    alt=''
                    className='mx-auto'
                  />
                </a>
              </button>
            </div>
          </div>

          <div className='md:w-1/3 space-y-4 py-4'>
            <div className='footer-links-wrapper'>
              <div>
                <h3 className='font-bold' style={{ marginBottom: 20 }}>
                  Useful Links
                </h3>

                <div>
                  <Link to={"/about"}>
                    <div className='mb-3'>
                      <p className='footer-link'>About Us</p>
                    </div>
                  </Link>
                  <Link to={"/contact-us"}>
                    <div className='mb-3'>
                      <p className='footer-link'>Contact Us</p>
                    </div>
                  </Link>
                </div>
              </div>

              <div>
                <h3 className='font-bold' style={{ marginBottom: 20 }}>
                  Policies
                </h3>

                <div>
                  <Link to={"/policy"}>
                    <div className='mb-3'>
                      <p className='footer-link'>Privacy Policy</p>
                    </div>
                  </Link>
                  <Link to={"/terms"}>
                    <div className='mb-3'>
                      <p className='footer-link'>Terms of Service</p>
                    </div>
                  </Link>
                  <Link to={"/accountDelete"}>
                    <div className='mb-3'>
                      <p className='footer-link'>Account Deletion</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className='md:w-1/3 space-y-4 py-4'>
            <div className='flex justify-center'>
              <div>
                <h3 style={{ marginBottom: 20 }}>Social Media</h3>

                <div className='social-media-wrapper'>
                  {socialMedia.map((social) => {
                    return (
                      <a href={social.link} target='_blank' key={social.name}>
                        <img src={social.icon} alt={social.name} />
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='bg-[#171717] text-[#FFFFFF33] overflow-hidden'>
        <div style={{ position: "relative", bottom: -30 }}>
          <MarqueeInfo />
        </div>
      </div> */}
    </>
  );
};

export default BottomSection;
